import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
// import { BrowserRouter } from 'react-router-dom';
import { HashRouter } from 'react-router-dom';
import { UserContextProvider } from "./context/userContext";
import './style.css'

  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <HashRouter>
      <UserContextProvider>
        <App />
      </UserContextProvider>
    </HashRouter>
  );